const PopupPositions = ["Right", "Center", "Left"];
const PopupPositionRight = PopupPositions[0];
const PopupPositionCenter = PopupPositions[1];
const PopupPositionLeft = PopupPositions[2];
export {
  PopupPositionCenter,
  PopupPositionLeft,
  PopupPositionRight,
  PopupPositions
};
